"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculate_ratio_1 = require("./calculate-ratio");
exports.imageDimensions = {
    getImageDimensions(imageUrl) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.addEventListener('load', () => resolve({
                width: image.width,
                height: image.height,
                ratio: calculate_ratio_1.calculateRatio({ width: image.width, height: image.height }),
            }));
            image.addEventListener('error', () => reject({}));
            image.src = imageUrl;
        });
    },
};
//# sourceMappingURL=image-dimensions.js.map